import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import React from 'react';
import { Link } from 'react-router-dom';

import { SingleSignOnLogin } from '../../components/auth/single-sign-on-login';
import { Checkbox } from '../../components/ui/checkbox';
import { InputText } from '../../components/ui/input-text/input-text';
import { useRegister } from './use-register';

export const Register = () => {
  const {
    values,
    errors,
    onSubmit,
    loading,
    onChange,
    onToggleRememberMe,
    onToggleTOS,
    hasSubmitted,
    acceptedTOS,
    navigateLogin,
  } = useRegister();

  return (
    <>
      <Card title="Create an account">
        <SingleSignOnLogin />
        <Divider align="center">
          <span>or Sign up with Email</span>
        </Divider>
        <InputText name="email" placeholder="Email" error={errors.email} onChange={onChange} iconLeft="pi-user" />
        <InputText
          name="password"
          placeholder="Password"
          error={errors.password}
          onChange={onChange}
          iconLeft="pi-hashtag"
          password={true}
          toggleMask
        />
        <div className="field">
          <Checkbox label="Remember me" name="remember-me" checked={values.rememberMe} onChange={onToggleRememberMe} />
        </div>
        <div className="field">
          <Checkbox
            label={
              <>
                I accept the{' '}
                <Link to="/legal/privacy-policy" target="_blank" rel="noopener noreferrer">
                  privacy policy
                </Link>{' '}
                and{' '}
                <Link to="/legal/terms-and-conditions" target="_blank" rel="noopener noreferrer">
                  TOS
                </Link>{' '}
                *
              </>
            }
            error={hasSubmitted && !acceptedTOS ? 'Please accept the privacy policy and TOS to continue.' : false}
            name="accept-tos"
            checked={acceptedTOS}
            onChange={onToggleTOS}
          />
        </div>
        <div className="p-fluid flex">
          <Button
            label="Sign up"
            className="p-button-rounded"
            onClick={onSubmit}
            loading={loading}
            disabled={loading}
          />
        </div>
      </Card>
      <div
        className="p-4"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <span className="mr-2">Already have an account?</span>
        <Button label="Log in instead" onClick={navigateLogin} className="p-button-outlined ml-2" />
      </div>
    </>
  );
};
